export default "__VITE_ASSET__BQjuj$Rv__"